module.exports = __webpack_public_path__ + "static/media/dig2.d7a8cba4.png";